import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute.js';
import CrmDashboard from '../components/Products/Crm/CrmDashboard.jsx';

const CrmRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <PrivateRoute product="crm">
          <CrmDashboard />
        </PrivateRoute>
      }
    />
  </Routes>
);

export default CrmRoutes;
